import React from "react";
import ReactImageGallery from "react-image-gallery";
import {css, Theme} from "@emotion/react";

import "react-image-gallery/styles/css/image-gallery.css";
interface IProps {
    src: any[] | boolean;
    aws?: string;
}
const S3_BUCKET = "s3-zakupauto-service";
const REGION = "eu-central-1";

export const SliderComponent = (props: IProps) => {
    const gallImg =
        !props.aws && Array.isArray(props.src)
            ? props.src.map((img) => {
                  return {original: img.sizes.large, thumbnail: img.sizes.thumbnail};
              })
            : props.aws
              ? props.aws.split("|").map((img) => {
                    const url = `https://${S3_BUCKET}.s3.${REGION}.amazonaws.com/${img}`;
                    return {original: url, thumbnail: url};
                })
              : [];
    console.log("gallImg", gallImg);

    return (
        <div className="slider-container" css={sliderWrapper}>
            <ReactImageGallery items={gallImg} />
        </div>
    );
};

const sliderWrapper = (theme: Theme) => css`
    margin: 0 auto;
    width: 100%;
    border-color: white;

    .image-gallery-svg {
        color: ${theme.colors.brand_primary};
    }
    .image-gallery-thumbnail.active,
    .image-gallery-thumbnail:focus {
        border-color: ${theme.colors.brand_primary};
    }
`;
